import { createModel } from '@rematch/core';
import { v4 as uuid } from 'uuid';
import { RecordModel, RecordIDModel } from '@equifinance/shared';
import { RootModel } from '.';
import { ReferralReason } from './referralReasonsModel';

const fields = [
  'accountId',
  'chatId',
  'title',
  'description',
  'status',
] as const;
export type Referral = RecordIDModel<typeof fields[number]>;

const referralsModel = createModel<RootModel>()({
  ...RecordModel<Referral>(fields),
  effects: (dispatch) => ({
    async createReferral({ referral, referralReasons = [] } : {referral?: Partial<Referral>, referralReasons?: Partial<ReferralReason>[]}) {
      const chatId = await dispatch.chats.createChat();

      const id = uuid();
      dispatch.referrals.CREATE(id, { chatId, ...referral });

      referralReasons.forEach((referralReason) => {
        dispatch.referralReasons.createReferralReason({ referralId: id, ...referralReason });
      });

      return id;
    },
  }),
});

export default referralsModel;
